module.exports = __webpack_public_path__ + "img/IMG_2024_L_Foamcore.dab802f9.jpg";